import { render, staticRenderFns } from "./CustomAttributeValueUpdater.vue?vue&type=template&id=79f23c22"
import script from "./CustomAttributeValueUpdater.vue?vue&type=script&lang=ts"
export * from "./CustomAttributeValueUpdater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports